<template>
  <div>
    <template v-if="blockType == 'note'">
      <template v-if="blockData.excerpts.length">
        <excerpt
          v-for="excerpt in blockData.excerpts"
          :key="excerpt.id"
          :hover="hovering"
          variant=""
          :resource="blockData.resource"
          :excerpt="excerpt"
          class="mb-1 ml-0"
          v-bind="$props"
        ></excerpt>
        <component
          v-if="blockData.showSource"
          class="ml-2 pt-2"
          :is="comps[resourceType]"
          variant="footer"
          :blockData="blockData"
        ></component>
      </template>
      <template v-else>
        <component :is="comps[resourceType]" variant="full" :blockData="blockData"></component>
      </template>
    </template>
    <template v-else>
      <excerpt
        v-if="blockType == 'excerpt'"
        :resource="blockData.resource"
        :excerpt="blockData.excerpts[0]"
        :highlight="blockData.highlight"
      ></excerpt>
      <component v-else :is="comps[resourceType]" v-bind="$props"></component>
    </template>
  </div>
</template>

<script>
import Webpage from './Types/Webpage';
import Excerpt from './Types/Excerpt';
import Pdf from './Types/Pdf';
import Image from './Types/Image';
// import NoteFile from './NoteTypes/NoteFile';
// import NoteQuote from './NoteTypes/NoteQuote';
// import NoteWebsite from './NoteTypes/NoteWebsite';
// import NoteExcerpt from './NoteTypes/NoteExcerpt';
// import NotePost from './NoteTypes/NotePost';
// import ResourceActions from './ResourceActions';
/*
WidgetTypes:
excerpt
webpage
//comment
*/

export default {
  props: {
    hovering: {},
    blockData: {
      default: () => ({
        resource: {},
        excerpts: []
      })
    },
    blockType: { default: 'block' },
    variant: null
  },
  components: { Webpage, Excerpt },
  data() {
    return {
      comps: {
        webpage: Webpage,
        excerpt: Excerpt,
        pdf: Pdf,
        image: Image
      }
    };
  },
  computed: {
    resourceType() {
      //  return either webpage, image, pdf, doc or excerpt
      return this.blockData.resource ? this.blockData.resource.resourceData.type : undefined;
    }
  },
  methods: {}
};
</script>

<style scoped>
.resource-card {
  width: 100%;
}
</style>

<style>
.resource-card .title {
  font-size: 15px !important;
}
</style>
